// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformAdminPortalAccess = {
  accessPortalBaseUrl: "门户地址",
  accessLoginMode: "登录方式",
  accessAccountCenterUrl: "账号中心地址",
  accessDefaultRedirectPath: "默认跳转路径",
  accessShowHealthStatus: "显示健康状态",
  accessShowAccountCenter: "显示账号中心入口",
  accessTitle: "门户访问策略",
  accessSubtitle: "查看由 Endpoint Registry 派生的入口，并维护 Portal 运行策略。",
  accessNotice:
    "Portal 地址、域名和端口由 Endpoint Registry 统一管理；此页只维护默认跳转和门户展示策略。",
  accessEndpointTitle: "Registry 派生入口（只读）",
  accessEndpointSource: "入口来源",
  accessEndpointSourceValue: "Endpoint Registry · deploy/service-endpoints.json",
  accessEndpointReadOnlyNotice:
    "入口地址、域名和端口不能在此页编辑；如需调整，请修改 Endpoint Registry 并重新生成运行配置。",
  accessPolicyTitle: "Portal 运行策略",
  accessAccountCenterUrlUnavailable: "当前未提供",
} as const;
